
import { CycleConfig } from '../types/cycle';

export const sections: CycleConfig = {
  outer: [
    { 
      start: 1, end: 5, 
      color: '#E6B3CC', 
      label: 'MENSTRUATION'
    },
    { 
      start: 6, end: 11, 
      color: '#8DD4E6', 
      label: 'INFERTILE DAYS'
    },
    { 
      start: 12, end: 19, 
      color: '#90EE90', 
      label: 'FERTILE DAYS'
    },
    { 
      start: 20, end: 28, 
      color: '#E6D5BA', 
      label: 'INFERTILE DAYS'
    }
  ],
  radii: {
    outerBlue: 185,
    outer: 165,
    inner: 120,
    text: 142,
    numbers: 171  // Ajusté de 170 à 171 pour placer les numéros dans l'espace blanc
  }
};

